// extracted by mini-css-extract-plugin
export default {"wrapper":"tzmwLu","path":"oPiSst"};